import { useProfile } from 'hooks';
import { useTranslation } from 'react-i18next';

export const UserDetailsSection = () => {
  const user = useProfile();
  const { t } = useTranslation();

  const address = user?.addresses?.[0];

  return (
    <div className="bg-[#F5F7F9] rounded-[8px] p-[24px] md:h-full h-fit">
      <h1 className="font-[500] text-[18px]">
        {user?.firstName} {user?.lastName}
      </h1>
      <p>{user?.email}</p>
      <p>
        {user?.addresses.length > 0 && address
          ? `${address.Street || ''} ${address.HouseNumber || ''} ${address.PostCode || ''} ${address.City || ''} ${address.Country || ''}`
          : t('userDetails.noAddress')}
      </p>
      <div className="mt-5 font-[400]">
        <a href="/edit-profile" className="text-[#FF6F61]">
          {t('userDetails.edit')}
        </a>
      </div>
    </div>
  );
};
